import { render, staticRenderFns } from "./MembersExpireDialog.vue?vue&type=template&id=3c5f67cc&scoped=true"
import script from "./MembersExpireDialog.vue?vue&type=script&lang=js"
export * from "./MembersExpireDialog.vue?vue&type=script&lang=js"
import style0 from "./MembersExpireDialog.vue?vue&type=style&index=0&id=3c5f67cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5f67cc",
  null
  
)

export default component.exports